module.exports = __webpack_public_path__ + "img/header_bg.e987bc2f.png";